import { useSubsPopUpsStyles } from '~/shared/styles';
import { VStack } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import Button from '~/shared/Button';
import Pressable from '~/shared/Pressable';
import React from 'react';
import { SpIcon } from '~/shared/Icon';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '@springbig/shared';

type PopUpProps = {
    title: string;
    description: string;
    button: string;
    type?: 'warning' | 'info';
    isClosable?: boolean;
    isDismissable?: boolean;
    onProceed: () => void;
    onCancel?: () => void;
    onDismiss?: () => void;
};

const PopUpBanner = ({
    title,
    description,
    button,
    isClosable = true,
    isDismissable = false,
    onProceed,
    onCancel,
    onDismiss,
}: PopUpProps) => {

    const { t } = useI18n();

    const {
        text,
        background_warning,
        button_background_warning,
        button_text_warning,
    } = useSubsPopUpsStyles();

    return (
        <VStack
            bg={background_warning}
            p={4}
            space={4}
            alignItems={'center'}
            textAlign={'center'}
            w={'100%'}
            position={'relative'}
        >
            <VStack w={'100%'}>
                { isClosable &&
                    <Pressable
                        position={'absolute'}
                        onPress={onCancel}
                        color={text}
                    >
                        <SpIcon
                            icon={faTimes}
                            color={text}
                        />
                    </Pressable>
                }
                <H3 color={text}>
                    { title }
                </H3>
            </VStack>
            <Caption color={text}>
                { description }
            </Caption>
            <Button
                borderRadius={32}
                px={4}
                bg={button_background_warning}
                _text={{
                    color: button_text_warning,
                }}
                onPress={onProceed}
            >
                { button }
            </Button>
            { isDismissable &&
                <Pressable onPress={onDismiss}>
                    <Caption>{ t('subscriptions.popups.sub_prompt.dismiss') }</Caption>
                </Pressable>
            }
        </VStack>
    );
};

export default PopUpBanner;
